import Mustache from 'mustache';

import HTMLTemplate from '@/assets/export/template.html';
import DarkTheme from '@/assets/export/styles/dark.scss';
import LightTheme from '@/assets/export/styles/light.scss';
import SkyTheme from '@/assets/export/styles/sky.scss';

import HTMLBaseExportProvider from './htmlBase.provider';

export default class HTMLExportProvider extends HTMLBaseExportProvider {
  static EXTENSION = 'html';

  static THEMES = {
    dark: DarkTheme,
    light: LightTheme,
    sky: SkyTheme,
  }

  static async exportNote({
    note, options, editor, store,
  }) {
    // Set editor data to current note
    HTMLExportProvider.setEditorContent(editor, note.content);

    const content = await HTMLExportProvider.renderContent({
      store,
      noteUuid: note.uuid,
      content: editor.getHTML(),
    });

    const data = Mustache.render(HTMLTemplate, {
      title: note.summary,
      styles: HTMLExportProvider.THEMES[options.theme].toString(),
      content,
    });

    // Reset the editor data
    HTMLExportProvider.setEditorContent(editor, null);

    return data;
  }
}
